export enum MarkerIconSelected {
  hotel = 'https://svgshare.com/i/FAc.svg',
  destination = 'https://svgshare.com/i/EHe.svg',
  favorite = 'https://svgshare.com/i/Fot.svg',
  airport = 'https://svgshare.com/i/Eu_.svg',
  railway = 'https://svgshare.com/i/DCB.svg',
  ferry = 'https://svgshare.com/i/DHV.svg',
}
